import { FC } from 'react';
import { Typography, Tooltip } from 'antd';
import cs from 'classnames';
import styles from './index.module.less';
import IconFont from '@/common/components/IconFont';

const { Text } = Typography;

/**
 * @Description 顶部行
 */
const Row: FC<{
  total,
  openList,
  setOpenList,
  districtCluster, // 点击区时的数据
  setDistrictCluster,
  cityProvinceInfo
}> = ({
  total,
  openList,
  setOpenList,
  districtCluster, // 点击区时的数据
  setDistrictCluster,
  cityProvinceInfo
}) => {

  return (
    <div className={styles.rowCon}>
      {/* <Spin spinning={rightTopInfo?.isLoading}> */}
      <div
        className={styles.infoCon}
        style={{
          height: 37
        }}
        onClick={() => {
          setOpenList(!openList);
        }}
      >
        <span>
          {
            districtCluster.data ? <Tooltip
              placement='top'
              title='返回市级列表'
            >
              <span onClick={(e) => {
                setDistrictCluster({ data: null, isBack: true });
                e.stopPropagation();
              }}>
                <IconFont
                  iconHref='iconic_fanhui'
                  className={cs('c-006 fs-14 mr-4')}
                />
              </span>
            </Tooltip> : <></>
          }
          <span>
            <Text
              style={ { width: cityProvinceInfo?.name?.length > 4 ? 60 : 'auto' }}
              ellipsis={ { tooltip: cityProvinceInfo?.name }}
              className='fs-14 c-222'
            >
              {
                districtCluster?.data?.districtName ? districtCluster.data.districtName : cityProvinceInfo?.name
              }
            </Text>
            <>为您推荐<span className={cs('c-006 bold', styles.spanSpace)}>{total}</span>个开店区域 </>

          </span>
        </span>
        <IconFont
          iconHref='pc-common-icon-a-iconarrow_down'
          className={cs('c-959', openList ? styles.arrowIconUp : styles.arrowIcon, styles.icon)}
        />
      </div>
      {/* </Spin> */}
    </div>
  );
};

export default Row;
